// paths
export const PATH_PAIR = '/terminals/new';
export const PATH_TRANSACTIONS = '/transactions';
export const PATH_ACCOUNT_VERIFY = '/account-verify';
export const PATH_PRE_AUTH = '/pre-auth';
export const PATH_PAT = '/pay-at-table';
export const PATH_PURCHASE = '/';
export const PATH_REFUND = '/refund';
export const PATH_TERMINALS = '/terminals';
export const PATH_TERMINALS_SPI = `${PATH_TERMINALS}/spi`;
export const PATH_TERMINALS_SCI = `${PATH_TERMINALS}/sci`;

export const PATH_TERMINAL_DETAILS = '/terminal-details';
export const PATH_PAY_NOW = '/paynow';
export const PATH_SPLIT = '/paynow/split';
export const PATH_CASH_OUT = '/cashout';
export const PATH_ORDER_FINISHED = '/order-finished';
export const PATH_SETTINGS = '/settings';
export const PATH_SUPPORT = '/support';
export const PATH_PAIRINGS = '/pairings';

// link names
export const TEXT_FLEET_SETTINGS = 'Fleet settings';
export const TEXT_PAY_AT_TABLE = 'Pay at Table';
export const TEXT_ACCOUNT_VERIFY = 'Account Verify';
export const TEXT_PRE_AUTH = 'Pre-auth';
export const TEXT_PAT = 'Pay At Table';
export const TEXT_PURCHASE = 'Purchase';
export const TEXT_REFUND = 'Refund';
export const TEXT_CASHOUT = 'Cashout';
export const TEXT_TERMINALS = 'Terminals';
export const TEXT_SETTINGS = 'Settings';
export const TEXT_TRANSACTIONS = 'Transactions';
export const TEXT_TRANSACTION_DETAILS = 'Transaction Details';
export const TEXT_SUPPORT = 'Support';
